module.exports = __webpack_public_path__ + "static/media/4.1_preview.b6d3478d.png";